import { render } from "./Logbuch.vue?vue&type=template&id=39615f6f&scoped=true"
import script from "./Logbuch.vue?vue&type=script&lang=js"
export * from "./Logbuch.vue?vue&type=script&lang=js"

import "./Logbuch.vue?vue&type=style&index=0&id=39615f6f&scoped=true&lang=css"

import exportComponent from "/root/www/logbuch/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39615f6f"]])

export default __exports__